export const SearchTextInputComponent = {
  templateUrl: './app/ajs/_shared/components/search-text-input/search-text-input.component.html',
  bindings: {
    modelValue: '=',
    pattern: '@',
    onSearch: '&',
    width: '@',
    placeHolder: '@',
    isRequired: '=',
    isKeyUp: '=',
  },
  controller: SearchTextInputController,
  controllerAs: 'vm',
};

SearchTextInputController.$inject = ['$timeout'];

function SearchTextInputController($timeout) {
  let vm = this;

  vm.$onInit = function () {
    vm.isInputRequired = vm.isRequired === false ? false : true;
  };

  vm.clear = function () {
    delete vm.modelValue;

    // This is dulicating th API call because it is using on-enter-blur / on-blur-change
    $timeout(function () {
      // Hack
      vm.onSearch();
    }, 50);
  };
}

// angular
//     .module('app')
//     .directive('searchTextInput', SearchTextInputDirective);

// function SearchTextInputDirective() {
//     return {
//         scope: {},
//         bindToController: {
//             modelValue:  '=',
//             pattern:     '@',
//             onSearch:    '&',
//             width:       '@',
//             placeHolder: '@',
//             isRequired:  '=',
//             isKeyUp:     '='
//         },
//         restrict: 'E',
//         replace: true,
//         controller: SearchTextInputController,
//         controllerAs: 'vm',
//         templateUrl:  'core/directives/search-text-input/search-text-input.directive.html'
//     };
// }

// SearchTextInputController.$inject = ['$timeout'];

// function SearchTextInputController($timeout) {
//     let vm = this;

//     vm.$onInit = function() {
//         vm.isInputRequired = vm.isRequired === false ? false : true;
//         // vm.isInputKeyUp    = vm.isKeyUp === true ? true : false;
//     };

//     vm.clear = clear;
//     function clear(){
//         //vm.modelValue = '';

//         delete vm.modelValue;

//         // This is dulicating th API call because it is using on-enter-blur / on-blur-change
//         $timeout(function() { // Hack
//             vm.onSearch();
//         }, 50);
//     }
// }
